import { Tag } from 'ant-design-vue';
import { h } from 'vue';
// import { getCustomerTypeListApi } from '../admin/customer';
import { flatToTree, toCamel } from '/@/utils/common';
import { defHttp } from '/@/utils/http/axios';
import { useSysStoreWithOut } from '/@/store/modules/sys';

enum Api {
  FieldList = '/field/getField',
  OptionField = '/field/getOptionByField',
  GetSourceData = '/field/getSourceData',
  UserFieldSave = '/field/userFieldSave',
  FollowRecordList = '/record/index',
  CreateFollowRecord = '/record/save',
  FollowCategoryList = '/record/recordCategoryList',
  FollowWayList = '/category/categoryList',
  categorySave = '/category/categorySave',
  categoryDelete = '/category/categoryDelete',

  ActionRecordList = '/actionRecord/getDastList',

  AuthList = '/user/authList',
  FileList = '/file/getDataList',
  TransformedUserList = '/user/getTranseferUserList',
  UserList = '/user/getUserList',
  UserInfo = '/user/getUserInfo',
  StructureList = '/structure/structurList',
  SubStructurList = '/structure/subStructurList',
  subStructurUserList = '/structure/subStructurUserList',

  wecustomer = '/wecustomer/getWeCustomer',
  transferWeCustomer = '/wecustomer/transferCustomerRelation',

  ExamRecordList = '/examineFlow/recordList',

  SystemInterfaceList = '/system/interfaceList',
  SystemInterfaceUpdate = '/system/interfaceUpdate',

  SourceAdd = '/setting/sourceAdd',
  SourceDelete = '/setting/sourceDelete',

  ZoneList = '/address/getZones',
  CityList = '/address/getCities',
  DistrictList = '/address/getDistricts',
  AutoFillShippingInfo = '/address/autoFillShippingInfo',
  GetConfigData = '/common/getConfigData',
  ConfigDataSave = '/common/configDataSave',
}

// 审批记录
export const getExamRecordListApi = (params: any) =>
  defHttp.post<any>({
    url: Api.ExamRecordList,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 操作记录
export const getActionRecordListApi = (params: any) =>
  defHttp.post<any>({
    url: Api.ActionRecordList,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 创建跟进记录
export const createCreateFollowRecordApi = (params: any) =>
  defHttp.post<any>({
    url: Api.CreateFollowRecord,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 跟进记录列表
export const getFollowRecordListApi = (params: any) =>
  defHttp.post<any>({
    url: Api.FollowRecordList,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 跟进类型查询
export const getFollowCategoryListApi = async (params: any) => {
  const list = await defHttp.post<any>({
    url: Api.FollowCategoryList,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });
  return flatToTree(list, 0);
};

// 跟进方式查询
export const getFollowWayListApi = async (params: any) => {
  const data = await defHttp.post<any>({
    url: Api.FollowWayList,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });
  return data.types.map((i) => ({ value: i.id, label: i.name }));
};

// 原因类型编辑
export const CategorySaveApi = async (params: any) => {
  defHttp.post<any>({
    url: Api.categorySave,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });
};

// 原因类型删除
export const CategoryDeleteApi = async (params: any) => {
  defHttp.post<any>({
    url: Api.categoryDelete,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });
};

// 分配人员
export const getTransformedUserListApi = (params: { types: string; realname?: string }) =>
  defHttp.post<any>({
    url: Api.TransformedUserList,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 列表字段查询
export const getFieldListApi = async (params: any) => {
  const sysStore = useSysStoreWithOut();
  const data = await defHttp.post<any>({
    url: Api.FieldList,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

  return data.map((i) => {
    i.field = toCamel(i.field);
    if (['index', 'pool'].includes(params.action)) {
      if (i.field === 'allotStatus') {
        const allotMap = new Map([
          [0, { text: '待分配', color: 'orange' }],
          [1, { text: '分配中', color: 'green' }],
          [2, { text: '待处理', color: 'blue' }],
          [3, { text: '线索失效', color: 'red' }],
          [4, { text: '不分配', color: 'cyan' }],
          [5, { text: '已转化', color: 'purple' }],
          [6, { text: '已处理', color: 'green' }],
        ]);
        return {
          title: i.name,
          dataIndex: i.field, // 0-待分配 1-分配中 2-待处理 3-线索失效 4-不分配 5-已转化 6-已处理
          fixed: i.fixed,
          defaultHidden: i.hidden || false,
          customRender: ({ record }) => {
            const status = record?.allotStatus;
            const color = allotMap.get(status)?.color;
            const text = allotMap.get(status)?.text;
            if (!color || !text) return '';
            return h(Tag, { color: color }, () => text);
          },
        };
      }
      if (i.field === 'customerTypesId') {
        return {
          title: i.name,
          dataIndex: i.field,
          fixed: i.fixed,
          defaultHidden: i.hidden || false,
          customRender: ({ record: { customerTypesId } }) => {
            const customerTypesList: { typesId: number; types: string }[] =
              sysStore.customerTypesList;
            const text =
              customerTypesList.find((i) => i.typesId === customerTypesId)?.types || '--';
            return h(Tag, { color: '' }, () => text);
          },
        };
      }
      return {
        title: i.name,
        dataIndex: i.field,
        fixed: i.fixed,
        defaultHidden: i.hidden || false,
        width: i.field === 'name' || i.field === 'customerName' ? 250 : 150,
        sorter: ['createTime', 'updateTime', 'yearSales', 'allotTime'].indexOf(i.field) != -1 ? true : false,
      };
    }
    return i;
  });
};

// 用户功能权限列表
export const getUserAuthListApi = () =>
  defHttp.post<any>({
    url: Api.AuthList,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 附件列表 | 文件列表
export const getFileListApi = (params: any) =>
  defHttp.post<any>({
    url: Api.FileList,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 用户列表
export const getUserListApi = (params?: any) =>
  defHttp.post<any>({
    url: Api.UserList,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 获取用户信息
export const getUserInfoApi = (params?: any) =>
  defHttp.post<any>({
    url: Api.UserInfo,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 部门列表
export const getStructureListApi = (params?: any) =>
  defHttp.post<any>({
    url: Api.StructureList,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 权限范围内的部门列表
export const getSubStructureListApi = (params?: any) =>
  defHttp.post<any>({
    url: Api.SubStructurList,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 权限范围内的部门人员列表
export const getSubStructureUserListApi = (params?: any) =>
  defHttp.post<any>({
    url: Api.subStructurUserList,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 客户下的 用户账号列表
export const getWecustomerListApi = (params) =>
  defHttp.post<any>({
    url: Api.wecustomer,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 转移下单账号关联
export const transferWeCustomerRelationApi = (params) =>
  defHttp.post<any>({
    url: Api.transferWeCustomer,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 获取自定义字段选项
export const getOptionFieldApi = (params) =>
  defHttp.post<any>({
    url: Api.OptionField,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 获取客户来源
export const getSourceListApi = (params) =>
  defHttp.post<any>({
    url: Api.GetSourceData,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 获取域名接口列表
export const getSystemInterfaceList = (params) =>
  defHttp.post<any>({
    url: Api.SystemInterfaceList,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 修改域名接口
export const systemInterfaceUpdate = (params) =>
  defHttp.post<any>({
    url: Api.SystemInterfaceUpdate,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 添加客户来源
export const sourceAddApi = (params) =>
  defHttp.post<any>({
    url: Api.SourceAdd,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 删除客户来源
export const sourceDeleteApi = (params) =>
  defHttp.post<any>({
    url: Api.SourceDelete,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 自定义字段保存
export const userFieldSaveApi = (params) =>
  defHttp.post<any>({
    url: Api.UserFieldSave,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 获取省份
export const getZoneListApi = (params) =>
  defHttp.post<any>({
    url: Api.ZoneList,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 获取城市
export const getCityListApi = (params) =>
  defHttp.post<any>({
    url: Api.CityList,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 获取区/县
export const getDistrictListApi = (params) =>
  defHttp.post<any>({
    url: Api.DistrictList,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 自动识别地址
export const getAutoFillShippingInfoApi = (params) =>
  defHttp.post<any>({
    url: Api.AutoFillShippingInfo,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 获取配置
export const getConfigDataApi = (params) =>
  defHttp.post<any>({
    url: Api.GetConfigData,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 保存配置
export const configDataSaveApi = (params) =>
  defHttp.post<any>({
    url: Api.ConfigDataSave,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });
